import React, {useRef, useState} from "react";
import {Avatar, Button, Card, Empty, Input, List, Space, Tag, Typography,} from "antd";
import {PrinterOutlined, SearchOutlined, UserOutlined,} from "@ant-design/icons";

import {URLS} from "@/lib/urls";
import AdminLayout from "@/components/layout/admin/adminLayout";
import {useApiCreateAdminProductDeliveryActionReceipt, useApiSearchAdminProductsDeliveryOnly} from "@/api/product";
import ProductReceiptPrintV2 from "@/pages/admin/products/delivery/print/_section/Print";
import {useReactToPrint} from "react-to-print";
import RenderIf from "@/components/render-if";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {getJalaliDateTime} from "@/lib/utils/date";

const {Title, Text} = Typography;

function AdminProductReceiptSearchAndPrint() {
    const [keyword, setKeyword] = useState("");
    const [search, setSearch] = useState("");
    const [openModal, setOpenModal] = useState(false)

    const printRef = useRef(null);

    const handlePrint = useReactToPrint({
        contentRef: printRef,
        documentTitle: "Receipt",
    });

    const {data, isLoading,refetch} = useApiSearchAdminProductsDeliveryOnly({
        search : search,
        type : 'print'
    });

    const {mutate: deliveryAction, isPending: isPendingAction} = useApiCreateAdminProductDeliveryActionReceipt()

    const student = data?.data?.data?.id ? data?.data?.data : null ;

    function handlePrintReceipt()
    {
        if(!student)
        {
            return null
        }

        deliveryAction({
            action: 'print',
            student: student?.student,
        },{
            onSuccess: (r) => {
                ApiHandleSuccessMessage(r)
                refetch()
                handlePrint();
            },
            onError: (e) => {
                ApiHandleErrorMessage(e)
            }
        })


    }

    return (
        <AdminLayout
            backTo={URLS.admin.products.dashboard}
            pageTitle="صدور رسید تحویل اقلام"
        >
            <div className=" flex items-center justify-center p-6">

                <Card
                    className="w-full max-w-4xl rounded-3xl shadow-xl border-0"
                    bodyStyle={{padding: 40}}
                >

                    {/* سرچ */}
                    <div className="text-center mb-10">

                        <Title level={2} className="!mb-2">
                            جستجوی دریافت‌کننده اقلام آموزشی
                        </Title>

                        <Text type="secondary">
                            شماره موبایل یا کد ملی  را وارد کنید.
                        </Text>

                        <div className="mt-8 flex justify-center">
                            <Input.Search
                                size="large"
                                allowClear
                                enterButton={
                                    <>
                                        <SearchOutlined/>
                                        جستجو
                                    </>
                                }
                                loading={isLoading}
                                value={keyword}
                                placeholder="جستجو کنید ..."
                                className="max-w-xl"
                                onChange={(e) => setKeyword(e.target.value)}
                                onSearch={(v) => setSearch(v.trim())}
                            />
                        </div>
                    </div>

                    {/* هنوز سرچ نشده */}
                    {!search && (
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description="برای مشاهده اطلاعات، یک شماره موبایل یا  کد ملی  جستجو کنید."
                        />
                    )}
                    {search && !student && (
                        <Empty
                            image={Empty.PRESENTED_IMAGE_DEFAULT}
                            description="مورد جستجو شده یافت نشد!"
                        />
                    )}

                    {student && (
                        <div className="space-y-8">

                            <Card>
                                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">

                                    <Space size={20}>
                                        <Avatar

                                            size={72}
                                            icon={<UserOutlined/>}
                                            srcSet={student?.student_detail?.avatar}
                                        />

                                        <div>

                                            <Title level={3} className="mb-2">
                                                {student?.student_detail?.firstname}
                                                {' '}
                                                <b className={'mx-2'}>{student?.student_detail?.lastname}</b>
                                            </Title>

                                            <Space wrap>
                                                <Tag color="blue">
                                                    کد دانش‌آموز: {student?.student_detail?.code}
                                                </Tag>

                                                <Tag color="green">
                                                    {student?.student_detail?.mobile}
                                                </Tag>

                                                <Tag>
                                                    {student?.student_detail?.nationalcode}
                                                </Tag>
                                            </Space>

                                        </div>
                                    </Space>


                                </div>
                            </Card>

                            <Card
                                title={`اقلام قابل تحویل (${student?.product_delivery?.length})`}
                            >

                                <List
                                    itemLayout="horizontal"
                                    dataSource={student?.product_delivery}
                                    renderItem={(item) => (
                                        <List.Item>

                                            <List.Item.Meta
                                                avatar={
                                                    item.product.file?.url ? (
                                                        <Avatar
                                                            size={56}
                                                            shape="square"
                                                            src={item.product.file.url}
                                                        />
                                                    ) : (
                                                        <Avatar
                                                            size={56}
                                                            shape="square"
                                                        >
                                                            📦
                                                        </Avatar>
                                                    )
                                                }
                                                title={item.product.title}
                                                description={
                                                    <>
                                                        <div>
                                                            کد تحویل: {item.code}
                                                        </div>

                                                        {item.histories.length && (
                                                            <div className="  mt-1">
                                                                <div className="flex flex-col text-xs">
                                                                    {item.histories.map((h, i) => (
                                                                        <div key={h.id + 'history-product'} className={'flex flex-wrap gap-2 mb-1'}>
                                                                            <div>
                                                                                <RenderIf condition={h.action === "print"}>
                                                                                    <Tag color="blue">
                                                                                        چاپ شده
                                                                                    </Tag>
                                                                                </RenderIf>
                                                                                <RenderIf condition={h.action === "reprint"}>
                                                                                    <Tag color="geekblue">
                                                                                        چاپ مجدد
                                                                                    </Tag>
                                                                                </RenderIf>
                                                                                <RenderIf condition={h.action === "notif"}>
                                                                                    <Tag color="pink" title={h?.meta?.notif_text}>
                                                                                        ارسال پیامک
                                                                                    </Tag>

                                                                                </RenderIf>
                                                                                <RenderIf condition={h.action === "deliver"}>
                                                                                    <Tag color="green">
                                                                                        تحویل داده شده
                                                                                    </Tag>
                                                                                </RenderIf>

                                                                                <RenderIf condition={h.action === "deliver_to_teacher"}>
                                                                                    <Tag color="green">
                                                                                        تحویل داده شده به مربی
                                                                                    </Tag>
                                                                                </RenderIf>

                                                                            </div>
                                                                            <div>
                                                                                {h?.expert?.firstname}
                                                                                {' '}
                                                                                {h?.expert?.lastname}
                                                                            </div>
                                                                            <div>{getJalaliDateTime(h.datetime)}</div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </>
                                                }
                                            />

                                            <RenderIf condition={item?.status === 'pending'}>
                                                <Tag color="orange">
                                                    در انتظار تحویل
                                                </Tag>
                                            </RenderIf>
                                            <RenderIf condition={item?.status === 'print'}>
                                                <Tag color="blue">
                                                    چاپ شده
                                                </Tag>
                                            </RenderIf>
                                            <RenderIf condition={item?.status === 'deliver'}>
                                                <Tag color="green">
                                                    تحویل داده شده
                                                </Tag>
                                            </RenderIf>
                                            <RenderIf condition={item?.status === 'remove_lesson'}>
                                                <Tag color="red">
                                                    حذف درس
                                                </Tag>
                                            </RenderIf>



                                        </List.Item>
                                    )}
                                />

                            </Card>

                            <div className="text-center pt-2">

                                <Button
                                    onClick={handlePrintReceipt}
                                    size="large"
                                    type="primary"
                                    loading={isPendingAction}
                                    icon={<PrinterOutlined/>}
                                >
                                    چاپ رسید تحویل
                                </Button>

                            </div>

                        </div>
                    )}

                </Card>

            </div>


            <div className="flex justify-center">
                <div
                    ref={printRef}
                    className=""
                >
                    <ProductReceiptPrintV2

                        data={student} />
                </div>
            </div>

        </AdminLayout>
    );
}

export default AdminProductReceiptSearchAndPrint;